import { combineReducers } from '@reduxjs/toolkit'
import ContactsReducer from '@stores/contacts/contacts'

export default combineReducers({
	main: ContactsReducer,
})
